import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import OperateTabs_5 from "examples/Tabs/OperateTabs_5";

function Operate_5() {
  return (
    <DashboardLayout>
      <OperateTabs_5 />
    </DashboardLayout>
  );
}

export default Operate_5;
